import { Translation } from 'cng-common/features/translations'

import styles from './BusinessPriorities.module.scss'

export const BusinessPriorities = ({ names }: { names?: string[] }) =>
  names?.length ? (
    <div className={styles.root}>
      {names.map((name) => (
        <span key={name} className={styles.item}>
          <Translation text={name} span />
        </span>
      ))}
    </div>
  ) : null
